import {
  Box,
  Button,
  Flex,
  Heading,
  SlideFade,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { MovieCardProps } from "../../@types/MovieCard";
import { Image } from "../../components";
import ShowCaseTrailerModal from "../ShowCaseTrailerModal";

function MovieCard_1({
  title,
  poster,
  duration,
  videoLink,
  releaseDate,
  grade,
  isNowShowing = false,
  ...props
}: MovieCardProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const actionButtonProps = {
    size: "lg",
    variant: "outline",
    colorScheme: "primary",
    _hover: {
      background: "primary.500",
      color: "white",
      borderColor: "primary.500",
    },
    color: "white",
    borderColor: "white",
    px: "2.5rem",
    rounded: "full",
    fontWeight: 600,
  };
  return (
    <Box
      overflow="hidden"
      onMouseOver={onOpen}
      borderRadius="lg"
      onMouseLeave={onClose}
      {...props}
    >
      <Box
        position="relative"
        width="full"
        itemScope
        itemType="http://schema.org/Movie"
        itemProp="movie"
      >
        <Image
          className="movie__card__image"
          src={poster}
          alt={title}
          w="full"
          sx={{
            height: "27rem",
            objectFit: "cover",
          }}
          itemProp="image"
          itemScope
          title={title}
        />

        <Flex
          direction="column"
          background="rgba(0,0,0,0.5)"
          _hover={{
            background: "rgba(0,0,0,0.7)",
            opacity: 1,
          }}
          sx={{
            height: "100%",
            zIndex: 1,
            width: "100%",
            backdropFilter: "blur(0.3rem)",
            opacity: 0,
            transition: "all 0.3s ease-in-out",
            position: "absolute",
            top: 0,
            left: 0,
            alignItems: "center",
            justifyContent: "center",
          }}
          gap={5}
        >
          <SlideFade
            in={isOpen}
            delay={{
              enter: 0.3,
            }}
            offsetX="70px"
          >
            {videoLink && (
              <ShowCaseTrailerModal
                url={videoLink}
                actionEl={<Button {...actionButtonProps}>Trailer</Button>}
              />
            )}
          </SlideFade>
          <SlideFade
            in={isOpen}
            delay={{
              enter: 0.3,
            }}
            offsetX="-70px"
          >
            <Button {...actionButtonProps}>Buy Now</Button>
          </SlideFade>
        </Flex>
        {grade && (
          <Button
            sx={{
              position: "absolute",
              top: "1rem",
              right: "1rem",
            }}
            _hover={{}}
            w={10}
            h={10}
            color="white"
            aria-readonly
            background="primary.500"
            rounded="full"
            size="md"
          >
            {grade}
          </Button>
        )}
      </Box>
      <Box mt={4}>
        <Heading
          mb={1}
          size="md"
          color="surface.700"
          textTransform="capitalize"
          itemProp="name"
          title={title}
        >
          {title}
        </Heading>
        {!isNowShowing && (
          <Text
            fontSize="sm"
            fontWeight={500}
            textTransform="capitalize"
            color="surface.300"
            title="release-date"
          >
            Releasing on: {releaseDate}
          </Text>
        )}
        <Text
          fontSize="sm"
          fontWeight={500}
          textTransform="capitalize"
          color="surface.300"
          itemProp="duration"
        >
          {!isNowShowing && "Runtime: "} {duration}
        </Text>
      </Box>
    </Box>
  );
}

export default MovieCard_1;
